<app-page-header
    [title]="'Planning' + (mobile ? '' : environment.isCodalt ? ' Codalt' : ' DvdS')"
    [subtitle]="environment.isCodalt ? 'Overzicht' : 'Dashboard'"
    [print]="print"
    [showPlanningFilter]="true"
    (selectedTeams)="selectedTeamsChange($event)"
    (headerClick)="setCenterDate()">
    <div class="d-flex align-items-center" indicator>
        @if (!mobile && !print) {
            <div class="team-selector flex-column d-flex">
                <app-planning-filter (selectedTeams)="selectedTeamsChange($event)"></app-planning-filter>
            </div>
        }

        <app-date-indicator
            [fromDate]="fromDate"
            [primaryWeekEnd]="primaryWeekEnd"
            [primaryWeekStart]="primaryWeekStart"
            [print]="print"
            [toDate]="toDate"
            (next)="next()"
            (prev)="prev()">
        </app-date-indicator>
    </div>

    <div class="d-flex mx-2" print-pdf>
        @if (!print) {
            <input
                #dateInput
                [matDatepicker]="picker"
                (dateChange)="onDateSelected($event)"
                matInput
                style="border: none; width: 0px; height: 0px" />

            <button class="menu-button" (click)="openPicker()" color="primary" mat-icon-button>
                <mat-icon class="calendar-icon" fontSet="far" fontIcon="fa-calendar-range"></mat-icon>
            </button>

            <mat-datepicker #picker [touchUi]="mobile" (dateChange)="onDateSelected($event)"> </mat-datepicker>
        }
    </div>

    <div class="d-none d-lg-flex" print-pdf>
        @if (!print) {
            <button class="menu-button" (click)="exportPlanningPdf()" color="primary" mat-icon-button>
                <mat-icon fontSet="far" fontIcon="fa-file-pdf"></mat-icon>
            </button>
        }
    </div>
</app-page-header>

<div class="planning-overview" [class.print]="print">
    <div class="legend" [class.print]="print">
        <div class="fakedate"></div>
        @if (!planningEntities) {
            <div class="loading">Laden...</div>
        }
        @for (entity of planningEntities; track entity.id; let i = $index) {
            <div
                class="entity"
                [class.no-plannings]="!entityIdPlanningCount.get(entity.id)"
                [class.big]="entity.entitytypes[0]?.is_team"
                [class.divider]="entity.entitytypes[0]?.key !== planningEntities[i + 1]?.entitytypes[0]?.key"
                [matTooltip]="'entitytype-' + entity.entitytype_key | tt"
                [matTooltipShowDelay]="1500">
                <div class="icon"><i [class]="entity.entitytypes[0]?.icon"></i></div>
                {{ entity.name }}
            </div>
        }
        <div class="trucks" [matTooltip]="'trucks' | tt" [matTooltipShowDelay]="1500"></div>
        <div class="tons" [matTooltip]="'tons' | tt" [matTooltipShowDelay]="1500"></div>
    </div>
    <div class="days">
        @for (day of planningDays; track day) {
            <app-day
                [day]="day"
                [entityIdPlanningCount]="entityIdPlanningCount"
                [fixedUntil]="fixedUntil"
                [fromDate]="fromDate"
                [primaryWeekEnd]="primaryWeekEnd"
                [primaryWeekStart]="primaryWeekStart"
                [print]="print"
                [toDate]="toDate"
                [viewModel]="viewModel"
                (mouseEnterPlanning)="mouseEnterDate($event)"
                (mouseLeavePlanning)="mouseLeaveDate()"
                (openPlanning)="openPlanning($event)"
                (setFixed)="setFixed($event)">
            </app-day>
        }
    </div>
</div>
